import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { NODE_API_URL } from "./../../../env_config";
import PerfectScrollbar from "react-perfect-scrollbar";
import { toAbsoluteUrl, formatCcmodePrice } from "../../_helpers";
import { ConfirmStatusPopUpNew } from "./ConfirmStatusPopUpNew";
import { useDispatch, useSelector } from "react-redux";
import { updateShortlistStoneCount } from "../../../redux/commonRedux/common.actions";
import { toast } from "react-toastify";
import { FaEdit } from "react-icons/fa";
import DiamondTypeTag from "./DiamondTypeTag";
import CertificateLink from "../CertificateLink";

const perfectScrollbarOptions = {
    wheelSpeed: 1,
    wheelPropagation: false,
};
export const BuyPopUpNew = (props) => {
    const shortListedStoneCount = useSelector((state) => {
        return state.ShortlistStoneReducer?.shortlistStoneCount;
    });

    const dispatch = useDispatch();

    const [loader, setLoader] = useState(false);
    const {
        hideCertificateNumber,
        hideEstimatedShippingDays,
        isBuyRequest,
    } = useSelector((state) => state.CcModeSettingReducer);

    const [data, setData] = useState(props.data || []);

    useEffect(() => {
        if (props.data && props.data.length > 0) {
            setData(props.data);
        } else {
            setData([]);
        }
    },[props.data]);

    const [diamondstatusshow, setDiamondStatusShow] = useState(false);
    const [diamondstatus, setDiamondStatus] = useState([]);

    const handleClose = () => {
        props.setShow(false);
        setData((prev) => {
            return prev.map((el) => ({
                ...el,
                clientReference: "",
                addref: false,
            }));
        });
    };

    function handleBuyRequest(props) {
        const shortListIds = data.map((value) => value.Id);

        setLoader(true);
        axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/ccmode-buy-request`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            data: {
                shortListIds: shortListIds,
                userId: props.user.userId,
                currencyCode: localStorage.getItem("user_currency"),
            },
        })
            .then(function(res) {
                if (res.data.message === "UnAuthorized") {
                    localStorage.clear();
                    window.location.reload(true);
                }

                handleClose();
                setLoader(false);

                const statusMap = res.data.reduce(
                    (map, { CERTIFICATE, issuccess }) => {
                        map[CERTIFICATE] = issuccess
                            ? "Confirmed"
                            : "Not Confirmed";
                        return map;
                    },
                    {}
                );

                let confirmCount = 0;
                const finalstatus = data
                    .filter((item) => statusMap.hasOwnProperty(item.Certi_No))
                    .map((item) => {
                        const status = statusMap[item.Certi_No];
                        if (status === "Confirmed") {
                            confirmCount = confirmCount + 1;
                        }

                        return {
                            ...item,
                            status: status,
                        };
                    });

                dispatch(
                    updateShortlistStoneCount({
                        shortListedStoneCount:
                            shortListedStoneCount - confirmCount,
                    })
                );

                setDiamondStatusShow(true);
                setDiamondStatus(finalstatus);
            })
            .catch(function(err) {
                setLoader(false);
                if (err?.response?.data?.message) {
                    console.log("error", err?.response?.data.message);
                    toast.error(err?.response?.data?.message);
                }
            });
    }

    function handleShortlist(props) {
        setLoader(true);
        let certificates = data.map((value) => ({
            Certi_NO: value.Certi_No,
            client_ref: value.clientReference,
        }));
        axios({
            method: "POST",
            url: `${NODE_API_URL}/ccmode/ccmodeBuyDiamond`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            data: {
                user_id: props.user.CustomerId,
                diamonds: certificates,
                diamond_type: data[0].C_Color
                    ? data[0].diamond_type
                    : data[0].diamond_type + "F",
                ConsumerId: localStorage.getItem("C_id"),
            },
        })
            .then(function(res) {
                if (res.data.message === "UnAuthorized") {
                    localStorage.clear();
                    window.location.reload(true);
                }

                handleClose();
                setLoader(false);

                const statusMap = res.data.reduce(
                    (map, { CERTIFICATE, issuccess }) => {
                        map[CERTIFICATE] = issuccess
                            ? "Confirmed"
                            : "Not Confirmed";
                        return map;
                    },
                    {}
                );

                let confirmCount = 0;
                const finalstatus = data
                    .filter((item) => statusMap.hasOwnProperty(item.Certi_No))
                    .map((item) => {
                        const status = statusMap[item.Certi_No];
                        if (status === "Confirmed") {
                            confirmCount = confirmCount + 1;
                        }

                        return {
                            ...item,
                            status: status,
                        };
                    });

                dispatch(
                    updateShortlistStoneCount({
                        shortListedStoneCount:
                            shortListedStoneCount - confirmCount,
                    })
                );

                setDiamondStatusShow(true);
                setDiamondStatus(finalstatus);
                if (
                    finalstatus.filter((val) => val.status === "Confirmed")
                        .length
                ) {
                    axios({
                        method: "POST",
                        url: `${NODE_API_URL}/ccmode/buyUserLog`,
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem(
                                "accessToken"
                            )}`,
                        },
                        data: {
                            user_id: props.user.CustomerId,
                            activity_type: "Ccmode Buy",
                            user_agent: navigator.userAgent,
                            activity_data: finalstatus.filter(
                                (val) => val.status === "Confirmed"
                            ),
                            ip_address: localStorage.getItem("ipData"),
                            consumer_id: localStorage.getItem("C_id"),
                            diamond_type: "null",
                        },
                    })
                        .then((res) => {
                            if (res.data.message === "UnAuthorized") {
                                localStorage.clear();
                                window.location.reload(true);
                            }
                        })
                        .catch((error) => {});
                }
            })
            .catch(function(res) {});
    }

    function addReference(stone) {
        setData((prev) => {
            const result = prev.map((el) =>
                el.Id === stone.Id ? { ...el, addref: true } : el
            );

            return result;
        });
    }

    function handleClientReferenceChange(stone, event) {
        const value = event.target.value;

        setData((prev) =>
            prev.map((el) =>
                el.Id === stone.Id ? { ...el, clientReference: value } : el
            )
        );
    }

    return (
        <>
            <ConfirmStatusPopUpNew
                GetPricePerCarat={props.GetPricePerCarat}
                GetPrice={props.GetPrice}
                show={diamondstatusshow}
                data={data}
                onClose={() => setDiamondStatusShow(false)}
                diamondstatus={diamondstatus}
                language={props.language}
            />
            <Modal
                show={props.show}
                onHide={handleClose}
                className={"natTab"}
                backdrop="static"
                keyboard={false}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.language.CONFIRM_GOODS_POPUP_CONFIRM_ORDER}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 d-flex justify-content-between mb-3">
                            <span>
                                {
                                    props.language
                                        .CONFIRM_GOODS_POPUP_CONFIRM_DIAMOND
                                }{" "}
                                : {props.diamondcount}
                            </span>
                        </div>
                        <div className="col-12">
                            <PerfectScrollbar
                                options={perfectScrollbarOptions}
                                className="scroll border-bottom"
                                style={{
                                    maxHeight: "322px",
                                    position: "relative",
                                }}
                            >
                                <table className="table border-bottom">
                                    <thead>
                                        <tr className="bg-gray-100 sticky-top">
                                            <th className="text-center py-3 align-content-center">
                                                {
                                                    props.language
                                                        .CONFIRM_GOODS_POPUP_DIAMOND_DETAILS
                                                }
                                            </th>
                                            <th className="text-center py-3 align-content-center">
                                                {" "}
                                                {!hideEstimatedShippingDays
                                                    ? props.language
                                                          .CONFIRM_GOODS_POPUP_DIAMOND_SHIPPING_DAYS
                                                    : ""}
                                            </th>
                                            <th
                                                align="center"
                                                className="text-right py-3 align-content-center"
                                            >
                                                {
                                                    props.language
                                                        .CONFIRM_GOODS_POPUP_OURPRICEUSD
                                                }
                                                ({props.Currency}) <br />
                                                {props.Currency}/CT
                                            </th>
                                            {!isBuyRequest ? (
                                                <th className="text-right py-3 align-content-center w-160px">
                                                    {props.language.CCMODE_POPUP_CLIENT_REFERENCE}
                                                </th>
                                            ) : (
                                                ""
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data &&
                                            data.map((value, index) => {
                                                

                                                return (
                                                <tr
                                                    className={`position-relative`}
                                                    key={value.Id}
                                                >
                                                    <td>
                                                        <div className={`row`}>
                                                            <div className="col-2 text-center p-0">
                                                                {value.AWS_Image ? (
                                                                    <img
                                                                        className="img-fluid mr-2"
                                                                        alt={
                                                                            value.C_Shape
                                                                        }
                                                                        src={
                                                                            value.AWS_Image
                                                                        }
                                                                        onError={(
                                                                            e
                                                                        ) => {
                                                                            e.currentTarget.src = value?.sample
                                                                        }}
                                                                        width="50px"
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        className="img-fluid mr-2"
                                                                        alt={
                                                                            value.C_Shape
                                                                        }
                                                                        src={value?.sample}
                                                                        onError={(
                                                                            e
                                                                        ) => {
                                                                            e.currentTarget.src = toAbsoluteUrl(
                                                                                `/media/shape/noimage.png`
                                                                            );
                                                                        }}
                                                                        width="50px"
                                                                        style={{
                                                                            backgroundColor:
                                                                                "#f4f4f4",
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className="col-10 pl-2 p-0">
                                                                <div className="mb-1">
                                                                    <DiamondTypeTag diamondTypeTagColor={value.diamondTypeTagColor} diamondTypeTag={value.diamondTypeTag}/>

                                                                    <span className="small mr-2">
                                                                        {value.diamond_type ===
                                                                            "N" ||
                                                                        value.diamond_type ===
                                                                            "W"
                                                                            ? "N"
                                                                            : "L"}
                                                                        -
                                                                        {
                                                                            value.ProductId
                                                                        }
                                                                    </span>
                                                                    {!hideCertificateNumber && (
                                                                        <CertificateLink  Certificate_link={value.CERTIFICATE_LINK} lab={value.Lab} certificate={value.Certi_NO} className={`text-primary font-weight-bold mx-2 small`} />
                                                                    )}
                                                                </div>

                                                                <span className="text-dark font-weight-bold d-block">
                                                                    {
                                                                        value.C_Shape
                                                                    }{" "}
                                                                    {value.C_Weight &&
                                                                        value.C_Weight.toFixed(
                                                                            2
                                                                        )}{" "}
                                                                    {value.C_Color ===
                                                                    "fancy" ? (
                                                                        <>
                                                                            {
                                                                                value.f_intensity
                                                                            }{" "}
                                                                            {
                                                                                value.f_overtone
                                                                            }{" "}
                                                                            {
                                                                                value.f_color
                                                                            }{" "}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {
                                                                                value.C_Color
                                                                            }{" "}
                                                                        </>
                                                                    )}
                                                                    {
                                                                        value.C_Clarity
                                                                    }{" "}
                                                                    {
                                                                        value.C_Cut
                                                                    }{" "}
                                                                    {
                                                                        value.C_Polish
                                                                    }{" "}
                                                                    {
                                                                        value.C_Symmetry
                                                                    }{" "}
                                                                    {
                                                                        value.C_Fluorescence
                                                                    }{" "}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td
                                                        className={`text-center `}
                                                    >
                                                        {!hideEstimatedShippingDays
                                                            ? `${value.CustomerShippingDays} days`
                                                            : ""}
                                                    </td>
                                                    <td
                                                        className={`text-right text-primary `}
                                                    >
                                                        {value?.SELECTED_CURRENCY_LIST_PRICE_LABEL ||
                                                            formatCcmodePrice(
                                                                props.GetPrice(
                                                                    value
                                                                ),
                                                                props.Currency
                                                            )}
                                                        <br />
                                                        <span className="text-muted small">
                                                            {props.Currency}/CT{" "}
                                                            {value?.SELECTED_CURRENCY_LIST_PRICE_PER_CARAT_LABEL ||
                                                                formatCcmodePrice(
                                                                    props.GetPricePerCarat(
                                                                        value
                                                                    ),
                                                                    props.Currency
                                                                )}
                                                        </span>
                                                    </td>
                                                    {!isBuyRequest ? (
                                                        <td className="text-right align-content-center">
                                                            {value?.addref ? (
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={
                                                                        value?.clientReference ||
                                                                        ""
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        handleClientReferenceChange(
                                                                            value,
                                                                            e
                                                                        )
                                                                    }
                                                                    maxLength={
                                                                        30
                                                                    }
                                                                    placeholder={props.language.CCMODE_POPUP_ENTER_REFERENCE}
                                                                />
                                                            ) : (
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    overlay={
                                                                        <Tooltip id="tooltip">
                                                                            {props.language.CCMODE_POPUP_CLICK_TO_ADD_REFERENCE}
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <button
                                                                        className="btn btn-icon btn-outline-primary btn-sm"
                                                                        onClick={() =>
                                                                            addReference(
                                                                                value
                                                                            )
                                                                        }
                                                                    >
                                                                        <FaEdit className="font-size-h5" />
                                                                    </button>
                                                                </OverlayTrigger>
                                                            )}
                                                        </td>
                                                    ) : (
                                                        ""
                                                    )}
                                                </tr>
                                            )
                                            })}
                                    </tbody>
                                </table>
                            </PerfectScrollbar>
                            <div className="text-primary font-weight-bold mt-4 font-italic">
                                {props.diamondcount > 4
                                    ? props.language.CCMODE_POPUP_SCROLL_FOR_EXPLORE
                                    : ""}
                            </div>
                            <div className="row mt-5">
                                <div className="col-12 font-size-h6 text-right">
                                    {props.language.CCMODE_POPUP_PER} {props.Currency}/CT {props.language.CCMODE_POPUP_PRICE} :{" "}
                                    {formatCcmodePrice(props.totalpricepercarat, props.Currency)}
                                </div>
                                <div className="col-12 font-size-h6 mt-2 text-right font-weight-bolder">
                                    {props.language.CCMODE_COMMON_TOTAL} {props.Currency} : {formatCcmodePrice(props.totalourprice, props.Currency)}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className={`btn font-weight-bold btn-secondary`}
                        onClick={handleClose}
                    >
                        {props.language.CONFIRM_GOODS_POPUP_CLOSE}
                    </button>
                    <button
                        className={`btn font-weight-bold btn-primary ml-2`}
                        onClick={() => {
                            if (isBuyRequest) {
                                handleBuyRequest(props);
                            } else {
                                handleShortlist(props);
                            }
                        }}
                        disabled={loader}
                    >
                        {loader && (
                            <span className="ml-1 spinner spinner-white"></span>
                        )}
                        {isBuyRequest
                            ? props.language.CCMODE_POPUP_CONFIRM_BUY_REQUEST
                            : props.language.CONFIRM_GOODS_POPUP_CONFIRM_ORDER}
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
